// eslint-disable-next-line import/no-extraneous-dependencies
import "whatwg-fetch";

export const REQUEST_CHARGE = "REQUEST_CHARGE";
export const RECEIVE_CHARGE = "RECEIVE_CHARGE";
export const RECEIVE_ERROR = "RECEIVE_ERROR";

function requestCharge(uuid) {
  return {
    type: REQUEST_CHARGE,
    uuid
  };
}

function receiveCharge(uuid, charge) {
  return {
    type: RECEIVE_CHARGE,
    charge
  };
}

function receiveError(message) {
  return {
    type: RECEIVE_ERROR,
    message
  };
}

export function fetchCharge(uuid) {
  return dispatch => {
    dispatch(requestCharge(uuid));

    return window
      .fetch(`/public/charge/${uuid}`)
      .then(
        resp => resp.json(),
        error => {
          if (error instanceof TypeError) {
            setTimeout(() => {
              dispatch(fetchCharge(uuid));
            }, 1000);
          } else {
            dispatch(receiveError(error.message));
          }
        }
      )
      .then(json => {
        if (json) {
          if (json.error) {
            dispatch(receiveError(json.error));
          }
          dispatch(receiveCharge(uuid, json));
        }
      });
  };
}
